export default "__VITE_ASSET__xB8kM2_N__"